import { Injectable } from "@angular/core";
import { RestService } from "src/app/Services/Rest/rest.service";
import { login_body, getOTP_body } from "src/app/common";
import {
  commonConstants,
  RoutesAll,
  RequestURL,
  Cookies,
  lender,
} from "src/app/Constants/app.constants";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { KeycloakService } from "keycloak-angular";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

export class GenerateCaptcha {
  constructor(public user_name: string) {}
}

@Injectable()
export class LoginGstService {
  constructor(
    private restService: RestService,
    private router: Router,
    private httpClient: HttpClient
  ) {}

  callCaptchaApi(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  submitLogin(reuqestBody: any, requestURL: any, cb: any) {
    //  let apiAuthToken = this.getCookies(Cookies.apiToken);
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //  'client-security-token': apiAuthToken
      }),
    };
    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }
}
